import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useRegisterTokenCallbacks } from './hooks/useRegisterTokenCallbacks';
import Login from './components/Login';
import Verify2FA from './components/Verify2FA';
import Setup2FA from './components/Setup2FA';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Donors from './components/Donors';
import DonorDetail from './components/DonorDetail';
import Grants from './components/Grants';
import GrantDetail from './components/GrantDetail';
import Organizations from './components/Organizations';
import OrganizationDetail from './components/OrganizationDetail';
import Reports from './components/Reports';
import Admin from './components/Admin';
import Navigation from './components/Navigation';
import './App.css';

// Layout wrapper that shows navigation for authenticated routes
function AppLayout() {
  // Register AuthContext token callbacks globally
  useRegisterTokenCallbacks();
  
  const location = useLocation();
  
  // Pages that should NOT show navigation (login, 2FA, setup)
  const authPages = ['/login', '/verify-2fa', '/setup-2fa'];
  const showNavigation = !authPages.includes(location.pathname);

  return (
    <>
      {showNavigation && <Navigation />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/verify-2fa" element={<Verify2FA />} />
        <Route path="/setup-2fa" element={<Setup2FA />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/donors" 
          element={
            <ProtectedRoute>
              <Donors />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/donors/:id" 
          element={
            <ProtectedRoute>
              <DonorDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/grants" 
          element={
            <ProtectedRoute>
              <Grants />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/grants/:id" 
          element={
            <ProtectedRoute>
              <GrantDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/organizations" 
          element={
            <ProtectedRoute>
              <Organizations />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/organizations/:id" 
          element={
            <ProtectedRoute>
              <OrganizationDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/reports" 
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute requiredRole="admin">
              <Admin />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </Router>
  );
}

export default App;
